"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickIconSmall = TickIconSmall;
exports.default = TickIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function TickIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M19.1992 5L20.6543 6.37305L7.62109 19.7647L3 14.9282L4.45508 13.5552L7.6211 16.8506L19.1992 5Z",
    fill: "currentColor"
  }));
}
function TickIconSmall(props) {
  return (0, _core.jsx)(TickIcon, _extends({
    size: "small"
  }, props));
}